(function () {
  if (window.SP_LEGACY_VARIANT_COMPAT_LOADED) return;
  window.SP_LEGACY_VARIANT_COMPAT_LOADED = true;

  const selector = 'variant-radios[data-section], variant-selects[data-section]';

  function getOptions(picker) {
    if (picker.tagName.toLowerCase() === 'variant-radios') {
      return Array.from(picker.querySelectorAll('fieldset')).map((fieldset) => {
        const checked = fieldset.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }

    return Array.from(picker.querySelectorAll('select')).map((select) => select.value);
  }

  function getVariantData(picker) {
    if (picker._spVariantData) return picker._spVariantData;
    const json = picker.querySelector('script[type="application/json"]');
    if (!json) return [];

    try {
      picker._spVariantData = JSON.parse(json.textContent);
    } catch (error) {
      console.error('Shop Palestine variant data error:', error);
      picker._spVariantData = [];
    }

    return picker._spVariantData;
  }

  function getCurrentVariant(picker) {
    const options = getOptions(picker);
    if (options.some((option) => option === null)) return null;

    return getVariantData(picker).find((variant) =>
      variant.options.every((option, index) => option === options[index])
    );
  }

  function updateVariantInput(picker, variant) {
    const sectionId = picker.dataset.section;
    const forms = document.querySelectorAll(
      `#product-form-${sectionId}, #product-form-installment-${sectionId}`
    );

    forms.forEach((form) => {
      const input = form.querySelector('input[name="id"]');
      if (!input) return;
      input.disabled = false;
      input.value = variant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function updateURL(picker, variant) {
    if (!variant || picker.dataset.updateUrl === 'false') return;
    if (!picker.dataset.url) return;
    window.history.replaceState({}, '', `${picker.dataset.url}?variant=${variant.id}`);
  }

  function updateShareUrl(picker, variant) {
    const shareButton = document.getElementById(`Share-${picker.dataset.section}`);
    if (!shareButton || typeof shareButton.updateUrl !== 'function') return;
    shareButton.updateUrl(`${window.shopUrl || window.location.origin}${picker.dataset.url}?variant=${variant.id}`);
  }

  function updateMedia(picker, variant) {
    if (!variant || !variant.featured_media) return;
    const mediaGallery = document.getElementById(`MediaGallery-${picker.dataset.section}`);
    if (mediaGallery && typeof mediaGallery.setActiveMedia === 'function') {
      mediaGallery.setActiveMedia(`${picker.dataset.section}-${variant.featured_media.id}`, true);
    }
  }

  function updatePickupAvailability(variant) {
    const pickup = document.querySelector('pickup-availability');
    if (!pickup) return;

    if (variant && variant.available && typeof pickup.fetchAvailability === 'function') {
      pickup.fetchAvailability(variant.id);
    } else if (!variant || !variant.available) {
      pickup.removeAttribute('available');
      pickup.innerHTML = '';
    }
  }

  function updateAddButton(picker, variant) {
    const form = document.getElementById(`product-form-${picker.dataset.section}`);
    if (!form) return;

    const button = form.querySelector('[name="add"]');
    const text = button ? button.querySelector('span') : null;
    if (!button) return;

    if (!variant) {
      button.setAttribute('disabled', 'disabled');
      if (text && window.variantStrings) text.textContent = window.variantStrings.unavailable;
      return;
    }

    if (!variant.available) {
      button.setAttribute('disabled', 'disabled');
      if (text && window.variantStrings) text.textContent = window.variantStrings.soldOut;
      return;
    }

    button.removeAttribute('disabled');
    button.removeAttribute('aria-disabled');
    if (text && window.variantStrings) text.textContent = window.variantStrings.addToCart;
  }

  function updatePrice(picker, variant) {
    const sectionId = picker.dataset.section;
    const originalSection = picker.dataset.originalSection || sectionId;
    const destination = document.getElementById(`price-${sectionId}`);
    if (!destination || !picker.dataset.url || !variant) return;

    const requestId = String(variant.id);
    picker._spLatestPriceRequest = requestId;

    fetch(`${picker.dataset.url}?variant=${variant.id}&section_id=${originalSection}`)
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.text();
      })
      .then((responseText) => {
        if (picker._spLatestPriceRequest !== requestId) return;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const source = html.getElementById(`price-${originalSection}`);
        if (!source) return;
        destination.innerHTML = source.innerHTML;
        destination.classList.remove('visibility-hidden');
      })
      .catch((error) => {
        console.error('Shop Palestine price update error:', error);
      });
  }

  function removeProductError(picker) {
    const section = picker.closest('section');
    const productForm = section ? section.querySelector('product-form') : null;
    if (productForm && typeof productForm.handleErrorMessage === 'function') {
      productForm.handleErrorMessage();
    }
  }

  function handleVariantChange(picker) {
    const variant = getCurrentVariant(picker);
    const price = document.getElementById(`price-${picker.dataset.section}`);

    removeProductError(picker);
    updateAddButton(picker, variant);

    if (!variant) {
      if (price) price.classList.add('visibility-hidden');
      return;
    }

    updateVariantInput(picker, variant);
    updateURL(picker, variant);
    updateShareUrl(picker, variant);
    updateMedia(picker, variant);
    updatePickupAvailability(variant);
    updatePrice(picker, variant);
  }

  function initPicker(picker) {
    if (picker.dataset.spLegacyVariantCompat === 'true') return;
    picker.dataset.spLegacyVariantCompat = 'true';
    picker.addEventListener('change', () => handleVariantChange(picker));
  }

  function init(root) {
    if (root.matches && root.matches(selector)) initPicker(root);
    if (root.querySelectorAll) root.querySelectorAll(selector).forEach(initPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
